import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminSidebar.css";
import bhashini_logo from "../images/bhashini_logo.png";
import user_management_icon from "../images/user-management.png";
import book_management_icon from "../images/book_management.png";
import logout_icon from "../images/logout_icon.png";
import { getToken, setToken } from "../storage/Storage"; // Import your storage functions
import { speakText } from "./utils/speechUtils"; // Import the speech utility

const AdminSidebar = ({ activeItem, setActiveItem, resetSearch, disableSpeech }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [token, setTokenState] = useState(null); // State to store the resolved token value
  const navigate = useNavigate();
  const menuItemRefs = useRef([]);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const storedToken = await getToken();
        setTokenState(storedToken);
      } catch (error) {
        console.error("Failed to fetch name", error);
      }
    };
    fetchToken();
  }, []);

  const handleLogout = async () => {
    // Clear the token and other user data from localStorage
    try {
      await setToken("");
      console.log("User logged out");

      // Navigate to the landing page after logout
      navigate("/");
    } catch (error) {
      console.error("Error logging out", error);
    }
  };

  const menuItems = [
    { icon: book_management_icon, activeIcon: book_management_icon, label: "Book Management", key: "bookManagement" },
    { icon: user_management_icon, activeIcon: user_management_icon, label: "User Management", key: "userManagement" },  ];

  const bottomMenuItems = [
    { icon: logout_icon, label: "Logout", key: "logout", disabled: false },
  ];

  const handleItemClick = (item) => {
    if (item.key === "logout") {
      handleLogout();
    } else if (!item.disabled) {
      setActiveItem(item.key);
      if (item.key === "home") {
        resetSearch();
      }
    }
  };

  const handleKeyDown = (event, item) => {
    if (event.key === "Enter") {
      handleItemClick(item);
    }
  };
  const handleImageFocus = (event) => {
    if (!disableSpeech) {
      const altText = event.target.alt; // Get the alt text of the image
      speakText(altText);  // Speak the alt text aloud
    }
  };
  return (
    <div className="sidebar">
      {/* Top section with icons */}
      <div className="sidebar-top">
        <div className="logo-container">
          <a href="/Book-Management">
            <img src={bhashini_logo} alt="Welcome to Drishti Library" className="logo" tabIndex={0}
              onFocus={handleImageFocus} />
          </a>
        </div>
        {menuItems
          .filter((item) => token || item.key === "bookManagement") // Show only "Dashboard" if no token
          .map((item, index) => (
            <div
              key={item.key}
              ref={(el) => (menuItemRefs.current[index] = el)}
              tabIndex={0}
              className={`sidebar-icon ${activeItem === item.key ? "active" : ""}`}
              onClick={() => handleItemClick(item)}
              onMouseEnter={() => setHoveredItem(item.key)}
              onMouseLeave={() => setHoveredItem(null)}
              onFocus={() => !disableSpeech && speakText(item.label)} // Trigger speech when focused
              onKeyDown={(e) => handleKeyDown(e, item)}
            >
              <img
                src={
                  activeItem === item.key || hoveredItem === item.key
                    ? item.activeIcon
                    : item.icon
                }
                alt={`${item.label} Icon`}
              />
            </div>
          ))}
      </div>

      {/* Bottom section with icons */}
      {token && ( // Render bottom menu only if token exists
        <div className="sidebar-bottom">
          {bottomMenuItems.map((item, index) => (
            <div
              key={item.key}
              ref={(el) => (menuItemRefs.current[menuItems.length + index] = el)}
              tabIndex={0}
              className={`sidebar-icon ${activeItem === item.key ? "active" : ""}`}
              onClick={() => handleItemClick(item)}
              onFocus={() => !disableSpeech && speakText(item.label)} // Trigger speech when focused
              onKeyDown={(e) => handleKeyDown(e, item)}
            >
              <img src={item.icon} alt={`${item.label} Icon`} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminSidebar;
